<div class="w-auto h-auto relative">
  <div class="flex justify-center absolute left-0 right-0" id="googleSignInButton" #googleSignInButton></div>
  <button (click)="initializeGoogleSignIn()" class="btn w-full">
    <span>
      <svg-icon src="@assets/images/google-icon.svg" class="block w-[18px]"></svg-icon>
    </span>
    <span i18n>Sign in with Google</span>
  </button>
</div>
